module.exports = "/_next/static/images/jamie-4142528953eca32bb030a6ef004fae59.png";